/**
 * Why ONE candidate row of a protocol step won or did not win.
 *
 * ── THIS IS THE ORDERED PRODUCT, NOT A DECORATION
 *
 * The client's order for the simulation is "detaillierte Informationen wie alles berechnet wurde".
 * The verdict per LOSER is that answer: the winner alone explains nothing, because the interesting
 * question is always why the row somebody expected to win did not. Candidates therefore arrive in
 * the engine's own evaluation order (`orderPriority` ascending, id as tie break) and no surface may
 * re-sort them — a re-sorted list silently rewrites the reason.
 *
 * Position-based mirror of the backend enum
 * {@code com.mvs.backend.cp.enums.ProvisionSimulationCandidateVerdict}. The wire form is the
 * ORDINAL (measured: `"verdict": 3` beside `"verdictInfo": {…}`), so the declaration order below
 * MUST match the backend exactly and new constants MUST only be appended at the end — never
 * inserted between existing ones (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionSimulationCandidateVerdict {

    /** Ordinal 0 — this row won the evaluation. */
    MATCHED,

    /** Ordinal 1 — a row before it had already won, so this one was never evaluated. */
    SHADOWED,

    /** Ordinal 2 — the row's own validity period does not contain the key date. */
    PERIOD_INVALID,

    /** Ordinal 3 — a constrained dimension of the row does not match the contract. */
    DIMENSION_MISMATCH,

    /** Ordinal 4 — the term band of the row does not contain the contract term. */
    TERM_BAND_MISMATCH,

    /** Ordinal 5 — the entry-age band of the row does not contain the age. */
    AGE_BAND_MISMATCH,

    /** Ordinal 6 — a personal row won, so group rows are never reached (BR-050). */
    AXIS_SHADOWED,

    /** Ordinal 7 — the component is not valid at the application date. */
    NOT_ACTIVE,

    /** Ordinal 8 — an EXCLUDE condition of the assignment's condition set matched ("durch Ausschluss-Bedingung ausgeschlossen"). */
    CONDITION_EXCLUDED,

    /** Ordinal 9 — no condition of the assignment's condition set matched ("keine Bedingung trifft zu"). */
    NO_CONDITION_MATCHED
}
